export const getInternalDocumentMenu = (screenCode: string) =>
  `portal-document/field/internal/${screenCode}`;

export const getInternalDocumentSubMenu = (screenCode: string) =>
  `portal-document/category/${screenCode}`;

export const getInternalDocsUrl = (screenCode: string) =>
  `portal-document/document/internal/${screenCode}`;

export const getInternalDocumentDetailUrl = (
  screenCode: string,
  docsId: string
) => `portal-document/document/internal/${screenCode}/${docsId}`;

export const getDocFormUrl = (screenCode: string) =>
  `portal-document/document/internal/${screenCode}/form`;
